<template>
  <div>
    <!-- <div class="chat_room"
         @click="optChatRoom">
      <b-icon-chat-square-dots class='chat_room_entry'></b-icon-chat-square-dots>
    </div> -->
    <el-drawer
      :show-close="false"
      :withHeader="false"
      :visible.sync="isOpenChatRoom"
      direction="btt"
      id="drawer"
      size='50%'
    >
      <ChatContent :userInfo="userInfo"></ChatContent>
    </el-drawer>
    <div class="hover_box">
      <el-popover
        width="250"
        class="btn_common"
        placement="left"
        :visible-arrow="false"
        trigger="hover"
        @hide="changeImg(0,'static/newVersionImgs/bottom_btn_APP.svg')"
        @show="changeImg(0,'static/newVersionImgs/bottom_btn_APP_active.svg')">
        <div slot="reference"
             class="btn_style">
          <img :src="btnSrcList[0]"
               class=" btn_app">
        </div>
        <div style="text-align:center;">
          <div style="text-align:center;width:90%;margin-left:5%;">{{$t('home.scanQRCode')}}</div>
          <img src="static/images/petal_google_play.png"
               style="width:180px;margin-top:15px;margin-bottom:10px">
          <div style="text-align:center;width:90%;margin-left:5%;">{{$t('home.orClick')}}
            <a style="color:grey;text-decoration: underline"
               href="https://download.petal.social/petal_latest.apk">{{$t('home.downloadDirectly')}}</a>
          </div>
        </div>
      </el-popover>
      <el-popover
        width="250"
        class="btn_common"
        placement="left"
        :visible-arrow="false"
        trigger="hover"
        @hide="changeImg(1,'static/newVersionImgs/bottom_btn_wx.svg')"
        @show="changeImg(1,'static/newVersionImgs/bottom_btn_wx_active.svg')">
        <div slot="reference"
             class="btn_style">
          <img :src="btnSrcList[1]"
               class="btn_wx">
        </div>
        <div style="text-align:center;">
          <div style="text-align:center;width:90%;margin-left:5%;">{{$t('home.scanWXQRCode')}}</div>
          <img src="static/newVersionImgs/wxAcount.png"
               style="width:200px;">
        </div>
      </el-popover>
      <el-popover
        popper-class="popover_text"
        class="btn_common pointer btn_mobile"
        placement="left"
        :visible-arrow="false"
        trigger="hover"
        @hide="changeImg(2,'static/newVersionImgs/bottom_btn_chat.svg')"
        @show="changeImg(2,'static/newVersionImgs/bottom_btn_chat_active.svg')">
        <div slot="reference"
             class="btn_style"
             @click="optChatRoom">
          <img :src="btnSrcList[2]"
               class="btn_chat">
        </div>
        <div>
          {{$t('home.talkAbout')}}
        </div>
      </el-popover>
      <el-popover
        popper-class="popover_text"
        class="btn_common pointer"
        placement="left"
        :visible-arrow="false"
        trigger="hover"
        @hide="changeImg(3,'static/newVersionImgs/bottom_btn_back.svg')"
        @show="changeImg(3,'static/newVersionImgs/bottom_btn_back_active.svg')">
        <div slot="reference"
             class="btn_style"
             @click="backToTop(0)">
          <img :src="btnSrcList[3]"
               class="btn_chat">
        </div>
        <div>
          {{$t('home.backToTop')}}
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import ChatContent from '@/components/ChatContent'
export default {
    props: {
        isMobileApp: process.env.PLATFORM === 'mobile_app',
        userInfo: {},
        isVideoDetail: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            isOpenChatRoom: false,
            btnSrcList: [
                'static/newVersionImgs/bottom_btn_APP.svg',
                'static/newVersionImgs/bottom_btn_wx.svg',
                'static/newVersionImgs/bottom_btn_chat.svg',
                'static/newVersionImgs/bottom_btn_back.svg'
            ]
        }
    },
    methods: {
        optChatRoom() {
            if (this.userInfo) {
                if (this.isVideoDetail) {
                    this.$parent.changeChatRoomStatus()
                } else {
                    this.changeChatRoomStatus()
                    this.$nextTick(() => {
                        this.$children[0].$children[0].optChatRoomContent()
                    })
                }
            } else {
                document.body.clientWidth < 769 ? this.$router.push('/login?login=1') : this.$bvModal.show('modal-login')
            }
        },
        changeChatRoomStatus() {
            this.isOpenChatRoom = !this.isOpenChatRoom
        },
        changeImg(idx, src) {
            this.btnSrcList[idx] = src
            this.$forceUpdate()
        },
        backToTop(targetPageY) {
            var timer = setInterval(function() {
                var currentY = document.documentElement.scrollTop || document.body.scrollTop
                var distance = targetPageY > currentY ? targetPageY - currentY : currentY - targetPageY
                var speed = Math.ceil(distance / 10)
                if (currentY === targetPageY) {
                    clearInterval(timer)
                } else {
                    window.scrollTo(0, targetPageY > currentY ? currentY + speed : currentY - speed)
                }
            }, 10)
        }
    },
    components: {
        ChatContent
    }
}
</script>
<style lang="scss">
    .popover_text{
        padding:10px;
        border:none;
        height:30px;
        color:#fff;
        background-color:#5d5d5d;
        text-align: center;
        line-height:10px;
    }
</style>
<style lang="scss" scoped>
>>>.el-drawer{
    background-color: #f8f8f8;
    overflow: scroll
}
>>>.el-drawer__container ::-webkit-scrollbar{
    display: none;
}

     .pointer{
         cursor: pointer;
     }

     @media screen and (max-width: 768px) {
         .hover_box{
         height: 50px !important;
         bottom:15% !important;

         .btn_common{
             display: none !important;
         }
         .btn_mobile{
             display: flex !important;
             height: 100% !important;
         }
         }
     }
.hover_box{
    width: 50px;
    height: 200px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
    background-color: #fff;
     position:fixed;
     bottom:5%;
     right:4%;
     z-index: 999;
     border-radius: 8px;
     display: flex;
     flex-direction: column;
    //  justify-content: space-around;
     align-items: center;

     .btn_common{
         width: 100%;
         height: 25%;
         display: flex;
        justify-content:center;
        align-items: center;
     }

     .btn_style{
         width:50px;
         height:50px;
         display: flex;
        justify-content:center;
        align-items: center;
     }

     .btn_common:hover{
     box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
     }

     .btn_back{
     }
}
.chat_room{
     position:fixed;
     bottom:10%;
     right:4%;
     cursor:pointer;
     z-index: 999;
     background-color: #FE4987;
     width: 50px;
     height: 50px;
     border-radius: 50%;
     display: flex;
     justify-content: center;
     align-items: center
 }
 .chat_room_entry{
     color: #fff;
     width: 28px;
     height: 28px;
 }
 @media only screen and (max-width:768px) {
  .chat_room_entry{
     width: 20px;
     height:20px;
 }
 .chat_room{
     width: 38px;
     height: 38px;
 }
 }
</style>



// WEBPACK FOOTER //
// src/components/ChatRoom.vue